import React, { useState, useEffect } from 'react';
import {
  Form,
  Input,
  Button,
  Card,
  message,
  Space,
  Typography,
} from 'antd';
import {
  ArrowLeftOutlined,
  SaveOutlined,
} from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { attributeService } from '../../services';

const { Title } = Typography;

const AttributeForm = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = !!id;

  useEffect(() => {
    if (isEdit) {
      loadAttribute();
    }
  }, [isEdit, id]);

  const loadAttribute = async () => {
    try {
      setLoading(true);
      const response = await attributeService.getById(id);
      if (response.success && response.data) {
        form.setFieldsValue({
          name: response.data.name
        });
      } else {
        message.error('Không thể tải thông tin thuộc tính');
        navigate('/attributes');
      }
    } catch (error) {
      //console.error('Error loading attribute:', error);
      message.error('Lỗi khi tải thông tin thuộc tính');
      navigate('/attributes');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      message.error('Vui lòng đăng nhập lại');
      return;
    }

    try {
      setSubmitting(true);
      const data = { ...values, accessToken };
      
      let response;
      if (isEdit) {
        response = await attributeService.update(id, data);
      } else {
        response = await attributeService.create(data);
      }

      if (response.success) {
        message.success(isEdit ? 'Cập nhật thuộc tính thành công' : 'Thêm thuộc tính thành công');
        navigate('/attributes');
      } else {
        message.error(response.message || `${isEdit ? 'Cập nhật' : 'Thêm'} thuộc tính thất bại`);
      }
    } catch (error) {
      //console.error('Error saving attribute:', error);
      const errorMsg = error.response?.data?.message || `Lỗi khi ${isEdit ? 'cập nhật' : 'thêm'} thuộc tính`;
      message.error(errorMsg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <Card>
        <div style={{ marginBottom: 24 }}>
          <Space>
            <Button
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate('/attributes')}
            >
              Quay lại
            </Button>
            <Title level={3} style={{ margin: 0 }}>
              {isEdit ? 'Chỉnh sửa thuộc tính' : 'Thêm thuộc tính mới'}
            </Title>
          </Space>
        </div>

        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          loading={loading}
          style={{ maxWidth: 600 }}
        >
          <Form.Item
            label="Tên thuộc tính"
            name="name"
            rules={[
              { required: true, message: 'Vui lòng nhập tên thuộc tính' },
              { min: 2, message: 'Tên thuộc tính phải có ít nhất 2 ký tự' },
              { max: 255, message: 'Tên thuộc tính không được quá 255 ký tự' }
            ]}
          >
            <Input 
              placeholder="Nhập tên thuộc tính (ví dụ: Màu sắc, Kích thước...)" 
              size="large"
            />
          </Form.Item>

          <Form.Item style={{ marginTop: 32 }}>
            <Space>
              <Button
                type="primary"
                htmlType="submit"
                icon={<SaveOutlined />}
                loading={submitting}
                size="large"
              >
                {isEdit ? 'Cập nhật thuộc tính' : 'Tạo thuộc tính'}
              </Button>
              <Button 
                size="large"
                onClick={() => navigate('/attributes')}
              >
                Hủy
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default AttributeForm;
